app.service('toCartError', function (front, log) {

	function prepareErrorType(message) {
		const defaultMapping = {
			'cart-max-product-count-message': 'amount_limit',
			'amount_limit': 'amount_limit',
			'PRODUCTS_IN_CART_LIMIT_EXCEEDED': 'cart_limit',
			'PRODUCT_QUANTITY_LIMIT_EXCEEDED': 'amount_limit',
			'OUTLET_PRODUCT_WITH_PRODUCT_IN_DIFFERENT_STATE': 'products_mixed',
			'NOT_ALLOWED_SHOP_ONLY_AND_STANDARD_PRODUCT_IN_CART': 'products_status6',
		};
		return defaultMapping[message] || message || '';
	}

	function sendEventAddToCartError (product) {
		const EVENT_ID = 'to_cart_err';
		const errorType = prepareErrorType(product.errorMessage);
		const frontPage = front.page();
		const callFromElement = product.callFromElement || 'button';
		const productType = product.productType || 'produkt';
		const isOperatorMode = product.isOperatorMode ? 'TO' : 'SI';

		const eventData = {
			id: EVENT_ID,
			f03: window.location.href,
			f04: product.productId,
			f05: productType,
			f06: errorType,
			f07: frontPage,
			f08: callFromElement,
			f09: product.productStatus,
			f10: product.paymentType,
			f23: front.getBrakepoint(),
			f24: isOperatorMode,
		};

		log.event(eventData);

		UA.push({
			event: EVENT_ID,
			event_details: [errorType, frontPage, product.productStatus],
		});
	}

	return {
		sendEventAddToCartError
	};
});
